export default __webpack_public_path__ + "static/media/adobe-illustrator.a7a02e07.svg";